import React, { useState } from "react"
import PropTypes from "prop-types"

import Menu from "./menu"
import "./style.css"
import "./responsive.css"

const Layout = ({ children }) => {

  let [activeMenu, setActiveMenu] = useState(false)

  return (
    <>
      <Menu active={activeMenu} />
      <button className="menuToggler" onClick={() => setActiveMenu(!activeMenu)}> 
        <span>Menu</span>
      </button>

        <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
